import {API_CONFIG, getHeaders} from '../config/api';
import {internalApi, getApiErrorMessage} from './internalApi';
import {transformDraftForAPI} from '../utils/transformers';

export const draftService = {
    createDraft: async (draft) => {
        try {
            const formattedDraft = transformDraftForAPI(draft);
            const response = await internalApi.post(
                API_CONFIG.ENDPOINTS.DRAFT,
                formattedDraft,
                {headers: getHeaders(draft.pharmacy, draft.partner)}
            );
            return response.data;
        } catch (error) {
            console.error('Error creating draft:', error);
            throw error;
        }
    },

    getAllDrafts: async (filters = {}) => {
        try {
            const queryParams = new URLSearchParams(filters).toString();
            const response = await internalApi.get(
                `${API_CONFIG.ENDPOINTS.DRAFT}?${queryParams}`,
                {
                    headers: getHeaders()
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching drafts:', error);
            throw error;
        }
    },

    getDraftById: async (draftId) => {
        try {
            const response = await internalApi.get(
                `${API_CONFIG.ENDPOINTS.DRAFT}/${draftId}`,
                {
                    headers: getHeaders()
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching draft:', error);
            throw error;
        }
    },

    updateDraft: async (draftId, draft) => {
        try {
            if (!draftId) throw new Error('Draft ID is required');

            const formattedDraft = transformDraftForAPI(draft);
            console.log('Formatted draft for API:', formattedDraft);

            const response = await internalApi.put(
                `${API_CONFIG.ENDPOINTS.DRAFT}/${draftId}`,
                formattedDraft,
                {headers: getHeaders(draft.pharmacy, draft.partner)}
            );
            return response.data;
        } catch (error) {
            console.error('Error updating draft:', error);
            throw error;
        }
    },

    deleteDraft: async (draftId) => {
        try {
            const response = await internalApi.delete(
                `${API_CONFIG.ENDPOINTS.DRAFT}/${draftId}`,
                {
                    headers: getHeaders()
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error deleting draft:', error);
            throw error;
        }
    },

    fetchOrderDataById: async (orderId) => {
        try {
            const response = await internalApi.get(
                `/app/public/internal/order/${orderId}`,
                {
                    headers: getHeaders()
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    saveDraft: async (updatedDraft) => {
        if (!updatedDraft.items || updatedDraft.items.length === 0) {
            throw new Error('Please add at least one item to the draft');
        }

        const invalidItems = updatedDraft.items.filter(item => !item.medicine || !item.medicine.id);
        if (invalidItems.length > 0) {
            console.error('Invalid items found:', invalidItems);
            throw new Error('There are invalid items in your draft. Please remove them and try again.');
        }

        const draftId = updatedDraft._id;
        await draftService.updateDraft(draftId, updatedDraft);
    },
    addShortbook: async (draft_id, medicine_id, order_id, strip_quantity) => {
        const qty = Number(strip_quantity);
        if (strip_quantity == null || Number.isNaN(qty) || qty < 1) {
            throw new Error('Enter a valid strip quantity (1 or more).');
        }
        try {
            const response = await internalApi.post(
                `${API_CONFIG.ENDPOINTS.DRAFT}/${draft_id}/shortbook`,
                { medicine_id, strip_quantity: qty },
                {
                    headers: {...getHeaders(), order_id }
                }
            );
            if(!order_id) {
                window.location.reload()
            }
            return response.data;
        } catch (error) {
            console.error('Error adding to shortbook:', error);
            throw new Error(getApiErrorMessage(error, 'Failed to add to shortbook'));
        }
    },
    billDraft: async (draft_id, options = {}) => {
        const { redeemWallet = false } = options;
        try {
            const response = await internalApi.post(
                `${API_CONFIG.ENDPOINTS.DRAFT}/${draft_id}`,
                { redeem_wallet: redeemWallet },
                { headers: getHeaders() }
            );
            window.open(`${process.env.REACT_APP_CE_BASE_URL}/app/accounts/1/conversations/${response.data.order_id}`, '_blank', 'noopener,noreferrer');
            return response.data;
        } catch (error) {
            console.log(error, "error")
            throw new Error(getApiErrorMessage(error, 'Unknown error'));
        }
    }
};
